import { render, staticRenderFns } from "./RegisterSoleProprietorModal.vue?vue&type=template&id=5a89773a&scoped=true&lang=pug"
import script from "./RegisterSoleProprietorModal.vue?vue&type=script&lang=js"
export * from "./RegisterSoleProprietorModal.vue?vue&type=script&lang=js"
import style0 from "./RegisterSoleProprietorModal.vue?vue&type=style&index=0&id=5a89773a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a89773a",
  null
  
)

export default component.exports